// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__2c_4l","question":"Question_question__3EgVh","sub":"Question_sub__YDOgo"};